import { Autocomplete, TextField, Box } from "@mui/material";
import { COUNTRIES_FULL, SelectCountryProps } from "../types/country-codes";
import { EMPTY_COUNTRY } from "../types/commons";

const COUNTRIES = [{ code: "", label: "Select a country" }, ...COUNTRIES_FULL];

export const SelectCountryUntranslated: React.FC<SelectCountryProps> = ({
  id,
  value,
  label,
  error,
  helperText,
  onChange,
  sx,
  required,
}) => {
  return (
    <Autocomplete
      sx={sx}
      id={id}
      value={value && value.code ? value : EMPTY_COUNTRY}
      onChange={onChange}
      //
      options={COUNTRIES}
      autoHighlight
      disableClearable
      getOptionLabel={(option) => {
        return option.code ? option.label : "";
      }}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      //
      renderOption={(props, option) => (
        <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            loading="lazy"
            width="20"
            src={option.code && `https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={option.code && `https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label} {option.code && "(" + option.code + ")"}
        </Box>
      )}
      //
      renderInput={(params) => (
        <TextField
          {...params}
          name={id}
          label={label}
          error={error}
          helperText={helperText}
          required={required}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};
